import * as fromReportesActions from './reportes.actions';
import { initialState, ReportesState } from './reportes.model';
import { Action, createReducer, on } from '@ngrx/store';


const methodReducer = createReducer(
  initialState,
  on(fromReportesActions.addProgramacionCorreo, (state, { _newProgramacionCorreoDto }) => ({
    ...state,
    programacion: _newProgramacionCorreoDto
  })),
  on(fromReportesActions.removeProgramacionCorreo, (state) => ({
    ...state,
    programacion: {}
  })),

);


// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function reducer(state: ReportesState | undefined, action: Action) {
  return methodReducer(state, action);
}






